<template>
  <div class="statisitcs-component-container">
    <el-tabs type="border-card" v-model="activename" style="height: 100%">
      <el-tab-pane
        :label="item.name"
        v-for="(item,index) in statisticsData"
        :key="item.dataKey"
        :name="'v'+index"
      >
        <ChartComponent v-if="activename == 'v'+index" :option="option" :index="index" style="height: calc(100vh - 60px);"></ChartComponent>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import ChartComponent from "./chart.vue";
export default {
  components: { ChartComponent },
  data() {
    return {
      activename:'v0',
      statisticsData: [],
      option: {
        title: {
          text: "Stacked Area Chart",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["Email"],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Email",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [120, 132, 101, 134, 90, 230, 210],
          },
        ],
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.DPC = this.$Core.getProvider("DPC");
      const statisticsData = await this.DPC.bindStatistics(
        this.DPC.threeDaysAgo(7),
        new Date()
      );
      console.log(statisticsData);
      let statistics = await this.DPC.bindTypeStatistics(
        this.DPC.Device.typeId,
        {
          IsDevice: true,
          BeginTime: this.DPC.threeDaysAgo(7),
          EndTime: new Date(),
          DeviceSn: this.DPC.Device.deviceSn,
        }
      );
      console.log(statistics);
      this.statisticsData = statistics;
    }
  },
};
</script>
<style lang="scss" scoped>
.statisitcs-component-container {
  height: 100%;
}
</style>